const PageLoader = () => {
  return (
    <div className="flex h-screen items-center justify-center bg-gray-200">
      <div className="spinner border-8 border-t-8 border-gray-500" />
    </div>
  );
};

export default PageLoader;
